<div class="set-password-container">
  <div class="set-password-card">
    <div class="set-password-header">
      <h1 class="set-password-logo">leah</h1>
      <p class="set-password-subtitle">Passwort festlegen</p>
    </div>

    @if (isValidating()) {
    <div class="loading-state">
      <p>Link wird überprüft...</p>
    </div>
    } @else if (!isTokenValid()) {
    <div class="error-state">
      <p>Dieser Link ist ungültig oder abgelaufen.</p>
      <p>Bitte fordern Sie einen neuen Link an.</p>
    </div>

    <div class="form-links">
      <a routerLink="/auth/forgot-password">Neuen Link anfordern</a>
    </div>
    } @else {
    @if (userEmail()) {
    <p class="set-password-email">Passwort festlegen für <strong>{{ userEmail() }}</strong></p>
    }

    @if (errorMessage()) {
    <div class="set-password-error">
      {{ errorMessage() }}
    </div>
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <label for="password">Neues Passwort</label>
        <p-password id="password" formControlName="password" placeholder="Neues Passwort eingeben" [feedback]="true"
          [toggleMask]="true" styleClass="w-full" inputStyleClass="w-full" />
        <div class="password-requirements">
          <p>Das Passwort muss enthalten:</p>
          <ul>
            <li [class.valid]="(form.get('password')?.value?.length ?? 0) >= 12">Mindestens 12 Zeichen</li>
            <li [class.valid]="!form.get('password')?.hasError('missingUpperCase')">Einen Großbuchstaben</li>
            <li [class.valid]="!form.get('password')?.hasError('missingLowerCase')">Einen Kleinbuchstaben</li>
            <li [class.valid]="!form.get('password')?.hasError('missingNumber')">Eine Zahl</li>
            <li [class.valid]="!form.get('password')?.hasError('missingSpecialChar')">Ein Sonderzeichen</li>
          </ul>
        </div>
      </div>

      <div class="form-field">
        <label for="confirmPassword">Passwort bestätigen</label>
        <p-password id="confirmPassword" formControlName="confirmPassword" placeholder="Passwort bestätigen"
          [feedback]="false" [toggleMask]="true" styleClass="w-full" inputStyleClass="w-full" />
        @if (form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched) {
        <small class="field-error">Passwörter stimmen nicht überein</small>
        }
      </div>

      <div class="form-actions">
        <p-button type="submit" label="Passwort festlegen" [disabled]="form.invalid" [loading]="isLoading()"
          styleClass="w-full" />
      </div>
    </form>
    }
  </div>
</div>